import { MaterialSymbols_400Regular } from '@expo-google-fonts/material-symbols/400Regular';

import { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_400Regular',
  font: MaterialSymbols_400Regular,
};
export default weight;
